import { render, staticRenderFns } from "./LeadDetail.vue?vue&type=template&id=5d803ec3&scoped=true&"
import script from "./LeadDetail.vue?vue&type=script&lang=js&"
export * from "./LeadDetail.vue?vue&type=script&lang=js&"
import style0 from "./LeadDetail.vue?vue&type=style&index=0&id=5d803ec3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d803ec3",
  null
  
)

export default component.exports